<template>
  <div>
    <div class="section-header">
      <h3>Positions</h3>
    </div>
    <div class="section-body d-flex flex-wrap ma-n1">
      <div class="ma-1" style="flex: 1 0 240px">
        <PositionCard card-title="Local Currency" :items="localCurrencyItem"></PositionCard>
      </div>
      <div class="ma-1" style="flex: 1 0 240px">
        <PositionCard
          card-title="Hard Currency"
          :to="`/countries/${region}/econ`"
          :items="hardCurrencyItem"
        ></PositionCard>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, inject, watchEffect, onMounted } from "vue"

import PositionCard from "@/components/CountrySummaryPositionCard.vue"
import { fmtNum } from "@/utils/vmMethods.js"
import type SovereignUniverse from "@/utils/SovereignUniverse"
import BlobApi, { type CsvRecord } from "@/apis/blobApi"

const sovereignUniverse = inject<SovereignUniverse>("sovereignUniverse")!
const blobApi = new BlobApi()

const props = defineProps<{ region: string }>()

const localCurrencyItem = ref<Record<string, string>>({})
const hardCurrencyItem = ref<Record<string, string>>({})

async function fetchData() {
  let rowsHC: Array<CsvRecord> = []
  let rowsLC: Array<CsvRecord> = []
  try {
    ;[rowsHC, rowsLC] = await Promise.all([
      blobApi.getCsvBlobData("enfusion-reports/Position_HC.csv"),
      blobApi.getCsvBlobData("enfusion-reports/Position_FX_LC.csv")
    ])
  } catch (err) {
    console.error("Error fetching CSV data:", err)
  }

  //use closure to prevent extra global scope variables
  return function update() {
    const alpha3 = sovereignUniverse.code2To3(props.region)
    const name = sovereignUniverse.fromAlpha2(props.region)?.name ?? ""
    const hcRecord = rowsHC.find((d) => d.EMDISOCode === alpha3)
    const lcRecord = rowsLC.find((d) => d.EMDRiskCountry === name)
    if (hcRecord) {
      hardCurrencyItem.value = {
        "Active Spread Duration": fmtNum(hcRecord["Active Duration Bet Yrs"], 3),
        "Active Cash": fmtNum(hcRecord["Active MV Bet"], 2, true)
      }
    }
    if (lcRecord) {
      localCurrencyItem.value = {
        "Active Duration": fmtNum(lcRecord["Active Duration Bet Yrs"], 3),
        "Active FX Exposure": fmtNum(lcRecord["EMDActiveLocalFXExposure"], 2, true)
      }
    }
  }
}

onMounted(async () => {
  const update = await fetchData()
  watchEffect(update)
})
</script>
